var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"flow__panel"},[(_vm.error)?_c('hh-error-display',{attrs:{"error":_vm.error}}):_c('loading-animation',[_vm._v("\n        "+_vm._s(_vm.commonResources.loadingMessage)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }